<template>
  <div class="cookiebox" v-if="cookieWarning">
    <div class="cookiebox__grid">
      <div>
        <svg id="Bold" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>cookie</title><path d="M22.724,6.527a1,1,0,0,0-1.308-.46A3.491,3.491,0,0,1,16.89,4.451a1,1,0,0,0-.582-.5.989.989,0,0,0-.765.059A3.376,3.376,0,0,1,14,4.38,3.5,3.5,0,0,1,10.5.88.762.762,0,0,0,9.587.135,12,12,0,1,0,24,11.88,11.8,11.8,0,0,0,22.724,6.527ZM3.917,14.713a1,1,0,1,1,1-1A1,1,0,0,1,3.917,14.713Zm4.75-8.166a2,2,0,1,1-2,2A2,2,0,0,1,8.667,6.547ZM9,18.88a2,2,0,1,1,2-2A2,2,0,0,1,9,18.88Zm4.667-7.75a1,1,0,1,1,1,1A1,1,0,0,1,13.667,11.13ZM15,19.88a1,1,0,1,1,1-1A1,1,0,0,1,15,19.88Zm3.5-4a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18.5,15.88Z"/></svg>
      </div>
      <div>
        <strong>Cookie notice</strong>
        <p>This website uses cookies to provide you with all features.</p>
        <p><router-link :to="{name: 'PrivacyPolicy'}">More Information</router-link></p>
      </div>
    </div>
    <div class="cookiebox__footer">
      <button class="button button--tiny" @click="ignoreCookieWarning">I Understand</button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('website', ['cookieWarning']),
  },
  methods: {
    ...mapActions('website', ['ignoreCookieWarning']),
  },
  mounted() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/Footer/CookieBox.vue